<template>
  <div id="etk_form_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
          <template v-if="cantAccessPage === true">
                <div class="page-name" >
                    <span class="page-title" id="etkHeader" v-if="$route.params.id > 0">Update Indirect Labor Code</span>
                    <span class="page-title" id="etkHeader" v-else>Add Indirect Labor Code</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackRequestList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content indirect-labour-crud">
                       <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal form-custom-select basic-form-container" id="IndirectLabourCodeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description " name="description">
                                        <div class="field-error">{{description_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Type:</label>
                                        <v-select v-model="type"
                                                name="type"
                                                placeholder="Select Type." label="text"
                                                :options="etkCodeTypeArr"
                                                :clearable="false">
                                                </v-select>
                                        <div class="field-error">{{type_err_msg}}</div>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="AddIndirectCodeBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="AddCode" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="AddIndirectCodeBtn"  v-else class="btn btn-primary" v-on:click.prevent="AddCode" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="AddAndContinueIndirectCodeBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="AddCode(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button  type="submit" id="cancelEtkBtn" class="btn btn-tertiary" v-on:click.prevent="BackRequestList" >
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                       </section>
                    </div>
                </div>
          </template>  
          <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
  </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';

var self;
export default {
  name:"AddETKCodes",


    metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Indirect Labor Code| " +process.env.COPYRIGHT_NAME : "Add Indirect Labor Code | " +process.env.COPYRIGHT_NAME}
  },
   mixins:[commonMixins],
   data: () => ({
     loading:false,
     code:"",
     description:"",
     code_err_msg:"",
     description_err_msg:"",
     cantAccessPage:"",
     permissions: [],
     etkCodeTypeArr:[{text:'Paid',value:'paid'},{text:'UnPaid',value:'unpaid'}],
     type:{text:'Paid',value:'paid'},
     type_err_msg:'',
   }),
   created: function() {

  },
  watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_indirect_code') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
  },
   mounted() {
     var self = this;
     self.getPermissions();
     setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {

                self.loadEtkCode();

            }
        }, 100);

   },
   methods: {
      BackRequestList() {
      var self = this;
      self.$router.push('/etk/list');
    },
    loadEtkCode() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/etk/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.code = data.content.code;
                    self.description = data.content.description;
                    self.type = {text:self.titleCase(data.content.type),value:data.content.type};
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'etk-by-id')
            }
        });
    },
     AddCode(flag){
        var error = false;

        var self = this;
        self.name_error_msg = "";
        self.type_err_msg = '';
        if (!self.code || self.code == '' || self.code == null) {
            self.code_err_msg = 'Code Required';
            error = true;
        }
        if (!self.description || self.description == ''||self.description == null) {
            self.description_err_msg = 'Description Required';
            error = true;
        }
        if (!self.type || self.type == ''||self.type == null || !self.type.value) {
            self.type_err_msg = 'Type Required';
            error = true;
        }
        if (!error) {
            self.loading = true;
              // var fields = {
              //     code:self.code,
              //     description:self.description,

              // };
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#AddIndirectCodeBtn").val("Updating ...");
                $("#AddIndirectCodeBtn").prop("disabled", true);
                $("#cancelEtkBtn").prop("disabled",true);
            } else {

                if (flag == "Save and Continue") {

                              $("#AddAndContinueIndirectCodeBtn").val("Saving ...");
                              $("#AddIndirectCodeBtn").prop("disabled", true);
                              $("#AddAndContinueIndirectCodeBtn").prop("disabled", true);
                              $("#cancelEtkBtn").prop("disabled",true);

                }else{

                              $("#AddIndirectCodeBtn").val("Saving ...");
                              $("#AddIndirectCodeBtn").prop("disabled", true);
                              $("#AddAndContinueIndirectCodeBtn").prop("disabled", true);
                              $("#cancelEtkBtn").prop("disabled",true);
                }
          }
            $.ajax({
                      url: process.env.ROOT_API + "/add-etklist",
                      type: "POST",
                      data: {code: self.code, description: self.description,type: self.type.value, id: segments[3]},
                      headers: this.ajxHeaders,
                      dataType: "json",
                      success: function (data) {
                          self.loading = false;


                          if (segments[3])
                          {
                              $("#AddIndirectCodeBtn").val("Update");
                              $("#AddIndirectCodeBtn").prop("disabled", false);
                              $("#cancelEtkBtn").prop("disabled",false);
                          } else {
                                if (flag == "Save and Continue") {

                                    $("#AddAndContinueIndirectCodeBtn").val("Save and Continue");
                                    $("#AddIndirectCodeBtn").prop("disabled", false);
                                    $("#AddAndContinueIndirectCodeBtn").prop("disabled", false);
                                    $("#cancelEtkBtn").prop("disabled",false);


                                } else {

                                    $("#AddIndirectCodeBtn").val("Save");
                                    $("#AddIndirectCodeBtn").prop("disabled", false);
                                    $("#AddAndContinueIndirectCodeBtn").prop("disabled", false);
                                    $("#cancelEtkBtn").prop("disabled",false);


                                }
                          }



                          if (data.status == "success") {

                              if (flag == "Save and Continue") {

                                // $("#IndirectLabourCodeForm").trigger("reset");
                                  self.code = "";
                                  self.description = "";


                              }
                              else{
                                //  $("#IndirectLabourCodeForm").trigger("reset");
                                   self.$router.push("/etk/list");

                              }
                          }else{
                              if (data.content.length > 0) {
                                  var err = "";
                                  for (var i = 0; i < data.content.length; i++) {
                                      err += data.content[i] + "<br>";
                                  }
                                  $("#errorMsg").html(err);
                                  $(".alert-warning").toggleClass("show");
                                  setTimeout(function () {
                                      $(".alert-warning").removeClass("show");
                                      $(".alert-warning").addClass("hide");
                                  }, 10000);
                              }
                          }




                      },
                        error: function (jqXHR, exception) {
                          self.loading = false;
                          if (segments[3])
                          {
                              $("#AddIndirectCodeBtn").val("Update");
                              $("#AddIndirectCodeBtn").prop("disabled", false);
                              $("#cancelEtkBtn").prop("disabled",false);
                          } else {

                              if (flag == "Save and Continue") {

                                  $("#AddAndContinueIndirectCodeBtn").val("Save and Continue");
                                  $("#AddIndirectCodeBtn").prop("disabled", false);
                                  $("#AddAndContinueIndirectCodeBtn").prop("disabled", false);
                                  $("#cancelEtkBtn").prop("disabled",false);

                              }else{

                                  $("#AddIndirectCodeBtn").val("Save");
                                  $("#AddIndirectCodeBtn").prop("disabled", false);
                                  $("#AddAndContinueIndirectCodeBtn").prop("disabled", false);
                                  $("#cancelEtkBtn").prop("disabled",false);

                              }
                          }
                          self.generateStatusCodeMessage(jqXHR,true,'etk-create')


                      }
                });
        }else{
            self.errorValidationFocus();
      }
    },



   },

}
</script>



// WEBPACK FOOTER //
// src/components/ETK/AddETKCodes.vue